/* ============================================================
   THE HAPPY FAULT — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Petal / Leaf Animation ──────────────────────────────────
  (function () {
    var canvas = document.getElementById('petalCanvas');
    if (!canvas || !window.__happyFaultTheme) return;

    var ctx = canvas.getContext('2d');
    var cfg = window.__happyFaultTheme;

    function resize() {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var items = [];

    function mkItem() {
      var isPetal = Math.random() > 0.38;
      var colors  = isPetal ? cfg.petalColors : cfg.leafColors;
      return {
        x: Math.random() * canvas.width,
        y: -20,
        r: isPetal ? (Math.random() * 5 + 3) : (Math.random() * 7 + 4),
        vx: (Math.random() - 0.5) * 0.55,
        vy: Math.random() * 0.65 + 0.38,
        rot: Math.random() * Math.PI * 2,
        rotV: (Math.random() - 0.5) * 0.028,
        alpha: Math.random() * 0.45 + 0.2,
        type: isPetal ? 'p' : 'l',
        color: colors[Math.floor(Math.random() * colors.length)],
        sw: Math.random() * 1.8,
        swS: Math.random() * 0.007 + 0.003,
        t: 0
      };
    }

    var count = Math.min(cfg.petalCount || 15, 30);
    for (var i = 0; i < count; i++) {
      var p = mkItem();
      p.y = Math.random() * canvas.height;
      items.push(p);
    }

    function drawItem(c, item) {
      c.save();
      c.translate(item.x, item.y);
      c.rotate(item.rot);
      c.globalAlpha = item.alpha;
      c.fillStyle = item.color;
      if (item.type === 'p') {
        c.beginPath();
        c.ellipse(0, 0, item.r, item.r * 1.7, 0, 0, Math.PI * 2);
        c.fill();
      } else {
        c.beginPath();
        c.ellipse(0, 0, item.r * 0.5, item.r, 0, 0, Math.PI * 2);
        c.fill();
        c.strokeStyle = item.color;
        c.globalAlpha = item.alpha * 0.45;
        c.lineWidth = 0.5;
        c.beginPath();
        c.moveTo(0, -item.r);
        c.lineTo(0, item.r);
        c.stroke();
      }
      c.restore();
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        item.t++;
        item.x += item.vx + Math.sin(item.t * item.swS) * item.sw * 0.35;
        item.y += item.vy;
        item.rot += item.rotV;
        if (item.y > canvas.height + 30) items[i] = mkItem();
        drawItem(ctx, item);
      }
      requestAnimationFrame(animate);
    }
    animate();

    setInterval(function () {
      if (items.length < count + 4) items.push(mkItem());
    }, 1900);
  })();

  // ── Market Modal ────────────────────────────────────────────
  (function () {
    var modal = document.getElementById('marketModal');
    if (!modal) return;

    var storageKey = 'happy_fault_region_selected';
    var chosenRegion = null;
    try {
      chosenRegion = localStorage.getItem(storageKey) || sessionStorage.getItem(storageKey);
    } catch (e) {
      chosenRegion = null;
    }

    var isThemeEditor = !!(window.Shopify && window.Shopify.designMode);
    var isLocalPreview = /^(127\.0\.0\.1|localhost)$/i.test(window.location.hostname);
    var editorHiddenKey = 'happy_fault_market_modal_editor_hidden';
    var editorHidden = false;
    try {
      editorHidden = sessionStorage.getItem(editorHiddenKey) === '1';
    } catch (e) {
      editorHidden = false;
    }

    if (isThemeEditor) {
      if (editorHidden) {
        modal.classList.add('hidden');
      } else {
        modal.classList.remove('hidden');
      }
    } else if (!chosenRegion) {
      modal.classList.remove('hidden');
    } else {
      modal.classList.add('hidden');
      updateRegionDisplay(chosenRegion);
    }

    document.querySelectorAll('[data-market-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var region = btn.getAttribute('data-market-btn');
        var form = document.getElementById('ModalLocalizationForm');
        try {
          localStorage.setItem(storageKey, region);
          sessionStorage.setItem(storageKey, region);
          if (isThemeEditor) sessionStorage.setItem(editorHiddenKey, '1');
        } catch (e) {}
        if (form) {
          var input = form.querySelector('[name=country_code]');
          if (input) input.value = region;
        }
        modal.classList.add('hidden');
        updateRegionDisplay(region);
        if (form && !isLocalPreview) form.submit();
      });
    });

    document.querySelectorAll('.region-dropdown-item[data-region]').forEach(function (item) {
      item.addEventListener('click', function (event) {
        if (!isLocalPreview) return;
        event.preventDefault();
        event.stopPropagation();
        var region = item.getAttribute('data-region') || 'GLOBAL';
        try {
          localStorage.setItem(storageKey, region);
          sessionStorage.setItem(storageKey, region);
        } catch (e) {}
        updateRegionDisplay(region);
        var dropdown = document.getElementById('regionDrop');
        if (dropdown) dropdown.classList.remove('open');
      });
    });

    function dismissModal() {
      try {
        localStorage.setItem(storageKey, 'dismissed');
        sessionStorage.setItem(storageKey, 'dismissed');
        if (isThemeEditor) sessionStorage.setItem(editorHiddenKey, '1');
      } catch (e) {}
      modal.classList.add('hidden');
    }

    var continueBtn = document.getElementById('marketModalContinue');
    if (continueBtn) {
      continueBtn.addEventListener('click', dismissModal);
    }

    var skipBtn = document.getElementById('marketModalSkip');
    if (skipBtn) {
      skipBtn.addEventListener('click', dismissModal);
    }

    var closeBtn = document.getElementById('marketModalClose');
    if (closeBtn) {
      closeBtn.addEventListener('click', dismissModal);
    }
  })();

  // ── Region Dropdown (header) ────────────────────────────────
  (function () {
    var btn  = document.getElementById('regionBtn');
    var drop = document.getElementById('regionDrop');
    if (!btn || !drop) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      drop.classList.toggle('open');
    });

    document.addEventListener('click', function (e) {
      if (!btn.contains(e.target) && !drop.contains(e.target)) {
        drop.classList.remove('open');
      }
    });
  })();

  // ── Update region display in header ────────────────────────
  function updateRegionDisplay(code) {
    var flagEl = document.getElementById('rgnFlag');
    var codeEl = document.getElementById('rgnCode');
    if (!flagEl || !codeEl) return;
    var map = { US: ['🇺🇸', 'US'], IN: ['🇮🇳', 'IN'], GLOBAL: ['🌍', 'GLOBAL'] };
    var v = map[code] || map.GLOBAL;
    flagEl.textContent = v[0];
    codeEl.textContent = v[1];
    document.querySelectorAll('.region-dropdown-item').forEach(function (el) {
      el.classList.toggle('active', el.getAttribute('data-region') === code);
    });
  }

  // ── Product description → accordion sections ───────────────
  (function () {
    var source = document.querySelector('.js-product-description-source');
    var mount = document.querySelector('.js-product-description-accordion');
    if (!source || !mount) return;

    var headings = (source.getAttribute('data-section-headings') || 'Details|Shipping|Care Instructions|Returns & Refunds')
      .split('|')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);

    var headingMap = {};
    headings.forEach(function (heading) {
      headingMap[heading.toLowerCase()] = heading;
    });

    var temp = document.createElement('div');
    temp.innerHTML = source.innerHTML;
    var nodes = Array.prototype.slice.call(temp.childNodes).filter(function (node) {
      return !(node.nodeType === 3 && !node.textContent.trim());
    });

    if (!nodes.length) return;

    function makeSection(title) {
      return { title: title, html: '' };
    }

    function normalizeText(text) {
      return (text || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function detectHeading(node) {
      if (!node || node.nodeType !== 1) return null;
      var tag = node.tagName.toUpperCase();
      var text = normalizeText(node.textContent);
      if (!text) return null;
      var lower = text.toLowerCase();

      if (/^H[1-6]$/.test(tag) && headingMap[lower]) return headingMap[lower];
      if ((tag === 'P' || tag === 'DIV') && headingMap[lower] && text.length <= 40) return headingMap[lower];
      if ((tag === 'P' || tag === 'DIV') && node.children.length === 1) {
        var childTag = node.children[0].tagName ? node.children[0].tagName.toUpperCase() : '';
        if ((childTag === 'STRONG' || childTag === 'B') && headingMap[lower]) return headingMap[lower];
      }
      return null;
    }

    var sections = [];
    var current = makeSection('Details');
    var foundExplicitHeadings = false;

    nodes.forEach(function (node) {
      var explicitHeading = detectHeading(node);
      if (explicitHeading) {
        foundExplicitHeadings = true;
        if (current.html.trim()) sections.push(current);
        current = makeSection(explicitHeading);
        return;
      }
      current.html += (node.outerHTML || node.textContent || '');
    });

    if (current.html.trim()) sections.push(current);

    if (!foundExplicitHeadings) {
      var rawText = temp.innerText || temp.textContent || '';
      var lines = rawText
        .split(/\r?\n/)
        .map(function (line) { return normalizeText(line); })
        .filter(Boolean);

      if (lines.length) {
        sections = [];
        current = makeSection('Details');

        lines.forEach(function (line) {
          var matchedHeading = headingMap[line.toLowerCase()];
          if (matchedHeading) {
            if (current.html.trim()) sections.push(current);
            current = makeSection(matchedHeading);
            return;
          }
          current.html += '<p>' + line + '</p>';
        });

        if (current.html.trim()) sections.push(current);
      }
    }

    if (!sections.length) return;

    mount.innerHTML = sections.map(function (section, index) {
      return '' +
        '<div class="accordion-item">' +
          '<button class="accordion-header" type="button">' +
            section.title.toUpperCase() +
            '<span class="accordion-icon">' + (index === 0 ? '−' : '+') + '</span>' +
          '</button>' +
          '<div class="accordion-content' + (index === 0 ? ' open' : '') + '">' + section.html + '</div>' +
        '</div>';
    }).join('');
  })();

  // ── Accordion (product page) ────────────────────────────────
  document.querySelectorAll('.accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var content = this.nextElementSibling;
      var icon    = this.querySelector('.accordion-icon');
      var isOpen  = content.classList.contains('open');

      // close all
      document.querySelectorAll('.accordion-content').forEach(function (c) { c.classList.remove('open'); });
      document.querySelectorAll('.accordion-icon').forEach(function (i) { if (i) i.textContent = '+'; });

      if (!isOpen) {
        content.classList.add('open');
        if (icon) icon.textContent = '−';
      }
    });
  });

  // ── Mobile Menu ─────────────────────────────────────────────
  (function () {
    var menuBtn  = document.querySelector('.mobile-menu-btn');
    var mobileNav = document.getElementById('mobileNav');
    if (!menuBtn || !mobileNav) return;

    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  // ── Sticky Header ───────────────────────────────────────────
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    if (header.classList.contains('sticky')) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('scrolled', window.scrollY > 10);
      });
    }
  })();

  // ── Product Gallery Thumbnails ──────────────────────────────
  (function () {
    document.querySelectorAll('.product-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.getAttribute('data-src');
        var main = document.querySelector('.product-main-image img');
        if (main && src) main.src = src;

        document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  })();

  // ── Quantity Buttons (product page only) ───────────────────
  (function () {
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      if (btn.closest('.cart-page')) return;
      btn.addEventListener('click', function () {
        var wrap   = this.closest('.qty-wrap');
        var display = wrap ? wrap.querySelector('.qty-display') : null;
        if (!display) return;
        var current = parseInt(display.textContent) || 1;
        var next = current;
        if (this.classList.contains('qty-plus')) {
          next = current + 1;
        } else if (this.classList.contains('qty-minus') && current > 1) {
          next = current - 1;
        }
        display.textContent = next;
        var hiddenInput = document.getElementById('qtyInput');
        if (hiddenInput) hiddenInput.value = next;
      });
    });
  })();

  // ── Cart line controls (qty + delete) ───────────────────────
  (function () {
    var cartPage = document.querySelector('.cart-page');
    if (!cartPage) return;

    function setUpdating(container, updating) {
      if (!container) return;
      container.classList.toggle('is-updating', updating);
      container.querySelectorAll('.qty-btn, .cart-item-remove').forEach(function (el) {
        if (updating) {
          el.setAttribute('aria-disabled', 'true');
          el.classList.add('is-disabled');
          if (el.tagName === 'BUTTON') el.disabled = true;
        } else {
          el.removeAttribute('aria-disabled');
          el.classList.remove('is-disabled');
          if (el.tagName === 'BUTTON') el.disabled = false;
        }
      });
    }

    function changeCartLine(line, quantity, fallbackUrl, container) {
      setUpdating(container, true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        window.location.href = fallbackUrl || '/cart';
      });
    }

    cartPage.addEventListener('click', function (event) {
      var removeLink = event.target.closest('.cart-item-remove');
      if (removeLink) {
        event.preventDefault();
        var removeLine = parseInt(removeLink.getAttribute('data-line'), 10);
        if (!removeLine) {
          window.location.href = removeLink.getAttribute('href');
          return;
        }
        var removeControls = removeLink.closest('.cart-item-controls');
        if (removeControls && removeControls.classList.contains('is-updating')) return;
        changeCartLine(removeLine, 0, removeLink.getAttribute('href'), removeControls);
        return;
      }

      var qtyBtn = event.target.closest('.cart-page .qty-btn');
      if (!qtyBtn) return;
      event.preventDefault();

      var wrap = qtyBtn.closest('.qty-wrap');
      var controls = qtyBtn.closest('.cart-item-controls');
      var display = wrap ? wrap.querySelector('.qty-display') : null;
      var line = wrap ? parseInt(wrap.getAttribute('data-line'), 10) : 0;

      if (!wrap || !display || !line || !controls || controls.classList.contains('is-updating')) return;

      var current = parseInt(display.textContent, 10) || 1;
      var next = current;
      if (qtyBtn.classList.contains('qty-plus')) {
        next = current + 1;
      } else if (qtyBtn.classList.contains('qty-minus')) {
        next = Math.max(1, current - 1);
      }

      if (next === current) return;
      changeCartLine(line, next, '/cart', controls);
    });
  })();

  // ── Product card quick add ──────────────────────────────────
  document.querySelectorAll('.product-quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var productUrl = btn.getAttribute('data-product-url');
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      var hasOnlyDefaultVariant = btn.getAttribute('data-has-only-default-variant') === 'true';

      if (!variantId) {
        if (productUrl) window.location.href = productUrl;
        return;
      }

      if (!hasOnlyDefaultVariant) {
        if (productUrl) window.location.href = productUrl;
        return;
      }

      var originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Quick add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'ADDED ✦';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = hasOnlyDefaultVariant ? 'VIEW PRODUCT' : originalText;
        btn.disabled = false;
        if (productUrl) {
          setTimeout(function () {
            window.location.href = productUrl;
          }, 200);
        }
      });
    });
  });

  // ── Add to Cart (Ajax) ──────────────────────────────────────
  var atcBtn = document.querySelector('.btn-add-to-cart');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var variantId  = document.querySelector('[name="id"]');
      var qtyDisplay = document.querySelector('.qty-display');
      if (!variantId) return;

      var formData = {
        items: [{
          id: parseInt(variantId.value),
          quantity: qtyDisplay ? parseInt(qtyDisplay.textContent) : 1
        }]
      };

      atcBtn.textContent = 'ADDING...';
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.textContent = 'ADDED ✦';
        setTimeout(function () {
          atcBtn.textContent = 'ADD TO STUDIO BAG';
          atcBtn.disabled = false;
        }, 2000);
        updateCartCount();
      })
      .catch(function () {
        atcBtn.textContent = 'ADD TO STUDIO BAG';
        atcBtn.disabled = false;
      });
    });
  }

  // ── Cart count badge ────────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = cart.item_count;
      });
  }
  updateCartCount();

  // ── Article table of contents ───────────────────────────────
  (function () {
    var content = document.querySelector('.js-article-content');
    var toc = document.querySelector('.js-article-toc');
    var tocWrap = document.querySelector('.js-article-toc-wrap');
    if (!content || !toc || !tocWrap) return;

    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      tocWrap.style.display = 'none';
      return;
    }

    headings.forEach(function (heading, index) {
      if (!heading.id) heading.id = 'article-section-' + (index + 1);
      var link = document.createElement('a');
      link.className = 'article-toc-item';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      toc.appendChild(link);
    });
  })();

  // ── Promo code apply ────────────────────────────────────────
  var promoBtn = document.querySelector('.promo-row button');
  if (promoBtn) {
    promoBtn.addEventListener('click', function () {
      var input = document.querySelector('.promo-row input');
      if (input && input.value) {
        // Shopify discount codes applied at checkout; redirect with code
        var code = encodeURIComponent(input.value.trim());
        window.location.href = '/checkout?discount=' + code;
      }
    });
  }

});
